(function(){
  var header=document.getElementById('tf-common-header');
  function updateHeaderHeight(){
    document.documentElement.style.setProperty('--tf-header-height',header.getBoundingClientRect().height+'px');
  }
  updateHeaderHeight();
  if(typeof ResizeObserver!=='undefined')new ResizeObserver(updateHeaderHeight).observe(header);
  window.addEventListener('resize',updateHeaderHeight,{passive:true});
})();

(function () {
  var trigger = document.getElementById('tf-cart-open');
  var dialog = document.getElementById('tf-cart-modal');
  var closeButton = document.getElementById('tf-cart-close');
  var savedPageState = null;
  var pointerStartedOutside = false;

  trigger.addEventListener('click', function () {
    if (dialog.open) return;
    savedPageState = {
      x: window.scrollX,
      y: window.scrollY,
      bodyStyle: document.body.style.cssText,
      rootOverflow: document.documentElement.style.overflow
    };
    dialog.showModal();
    document.documentElement.style.overflow = 'hidden';
    document.body.style.position = 'fixed';
    document.body.style.top = -savedPageState.y + 'px';
    document.body.style.left = -savedPageState.x + 'px';
    document.body.style.width = '100%';
    document.body.style.overflow = 'hidden';
    trigger.setAttribute('aria-expanded', 'true');
  });

  closeButton.addEventListener('click', function () {
    dialog.close();
  });

  function isOutsideDialog(event) {
    var bounds = dialog.getBoundingClientRect();
    return event.clientX < bounds.left || event.clientX > bounds.right ||
      event.clientY < bounds.top || event.clientY > bounds.bottom;
  }

  dialog.addEventListener('pointerdown', function (event) {
    pointerStartedOutside = event.target === dialog && isOutsideDialog(event);
  });
  dialog.addEventListener('pointercancel', function () {
    pointerStartedOutside = false;
  });
  dialog.addEventListener('click', function (event) {
    if (pointerStartedOutside && event.target === dialog && isOutsideDialog(event)) {
      dialog.close();
    }
    pointerStartedOutside = false;
  });

  // Native dialog handles Escape, focus containment and an inert background.
  dialog.addEventListener('close', function () {
    if (savedPageState) {
      document.body.style.cssText = savedPageState.bodyStyle;
      document.documentElement.style.overflow = savedPageState.rootOverflow;
      window.scrollTo(savedPageState.x, savedPageState.y);
      savedPageState = null;
    }
    pointerStartedOutside = false;
    trigger.setAttribute('aria-expanded', 'false');
    trigger.focus({ preventScroll: true });
  });
})();

// Position the compact footer popover without changing the page's height or scroll position.
(function () {
  var trigger = document.querySelector('.tf-footer-after-sales-trigger');
  var panel = document.getElementById('tf-footer-after-sales-panel');
  if (!trigger || !panel) return;
  function position() {
    if (!panel.matches(':popover-open')) return;
    var anchor = trigger.getBoundingClientRect();
    var box = panel.getBoundingClientRect();
    var width = document.documentElement.clientWidth;
    var height = window.innerHeight;
    var left = Math.max(16, Math.min(anchor.left, width - box.width - 16));
    var top = anchor.top - box.height - 12;
    if (top < 16 && anchor.bottom + 12 + box.height <= height - 16) top = anchor.bottom + 12;
    top = Math.max(16, Math.min(top, height - box.height - 16));
    panel.style.inset = 'auto';
    panel.style.margin = '0';
    panel.style.left = left + 'px';
    panel.style.top = top + 'px';
  }
  panel.addEventListener('toggle', function (event) {
    trigger.setAttribute('aria-expanded', String(event.newState === 'open'));
    if (event.newState === 'open') position();
  });
  window.addEventListener('resize', position, { passive: true });
  window.addEventListener('scroll', position, { passive: true, capture: true });
})();
